export default {
    load(src = '//api-maps.yandex.ru/1.1/index.xml?loadByRequire=1') {
        if (!this.promise) {
            this.promise = new Promise((resolve, reject) => {
                const scriptElement = document.createElement('script');
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                scriptElement.type = 'text/javascript';
                scriptElement.src = src;
                document.body.appendChild(scriptElement);
            }).then(() => {
               return  new Promise(resolve => {
                   YMaps.load(() => {
                        resolve(YMaps);
                    });
                });

            });
        }
        return this.promise;
    }
};